import { create } from 'zustand'

import { SearchParamsStore } from './types'

export const useSearchParamsStore = create<SearchParamsStore>()((set, get) => ({
  getSearchParams: ({ from }) => {
    return get()[from]
  },
  setSearchParams: ({ to, search }) => {
    set(state => ({
      ...state,
      [to]: search,
    }))
  },
}))
